/* eslint-disable camelcase */
import * as Sentry from '@sentry/browser';
import { useCallback } from 'react';
import { BalanceManagerApiService } from '@/services/api';

export type IpcaAdjustmentType = {
  contract_id: string;
  date_ipca: string;
  id: string;
  ipca_adjustment_id: string;
  open_balance_before_adjustment: string;
  payment_id: string;
  type: string;
  value: string;
  value_after_adjustment: string;
  value_tax: string;
  inserted_at: string;
  updated_at: string;
};

type UseIpcaAdjustmentType = {
  getIpcaAdjustments: (contractId: string) => Promise<IpcaAdjustmentType[]>;
};

function useIpcaAdjustment(): UseIpcaAdjustmentType {
  const getIpcaAdjustments = useCallback(
    async (contractId: string): Promise<IpcaAdjustmentType[]> => {
      const { api } = BalanceManagerApiService();

      try {
        const { data } = await api.get<IpcaAdjustmentType[]>(
          `/external/v1/statements/${contractId}/ipca_statements`,
        );

        return data;
      } catch (error) {
        Sentry.captureException(error, {
          extra: {
            message: 'Attempt to retrieve IPCA adjustments ended in failure',
          },
        });
      }

      return [];
    },
    [],
  );

  return { getIpcaAdjustments };
}

export default useIpcaAdjustment;
